import React from 'react';
import { Col, Row } from 'antd';
import { Tooltip } from '@b-design/fusion';
import $i18n from '@/i18n';
import ColorTags from '@/components/ColorTags';
import { getAppVersionStatus } from '@/utils/status';
import DefaultAppIcon from '../DefaultAppIcon';

import './index.less';
interface VersionDescription {
  // 应用logo地址
  iconPublicUrl: string;
}
interface VersionDetail {
  // 应用id
  appId: string;
  // 应用版本
  version: string;
  // 应用版本状态
  versionStatus: string;
  // 应用所属渠道名称
  channelName: string;
  // 版本描述
  versionDescription: VersionDescription;
}
interface Props {
  // 版本信息详情
  versionDetail: VersionDetail;
}

const AppInfo: React.FC<Props> = ({ versionDetail }) => {
  const { appId, version, versionStatus, channelName, versionDescription } = versionDetail;
  return (
    <div className="app-info">
      <Row>
        <Col span={6}>
          <div className="info-logo">
            {versionDescription?.iconPublicUrl ? (
              <img src={versionDescription?.iconPublicUrl} alt="" className="info-logo-img" />
            ) : (
              <DefaultAppIcon className="info-logo-img" />
            )}
            <div>
              <div className="info-id-title">
                {$i18n.get({
                  id: 'aopf.pages.miniapp.version.info.title.Miniapp.ID',
                  dm: '迷你应用ID',
                })}
              </div>
              <div className="info-id-text">{appId}</div>
            </div>
          </div>
        </Col>
        <Col span={6}>
          <div className="info-other">
            <div className="info-other-title">
              {$i18n.get({
                id: 'aopf.pages.miniapp.version.info.Version',
                dm: '版本',
              })}
            </div>
            <div className="info-other-text">v{version}</div>
          </div>
        </Col>
        <Col span={6}>
          <div className="info-other">
            <div className="info-other-title">
              {$i18n.get({
                id: 'aopf.pages.miniapp.version.info.title.Status',
                dm: '状态',
              })}
            </div>
            <div className="info-other-text">
              <ColorTags {...getAppVersionStatus(versionStatus)} />
            </div>
          </div>
        </Col>
        <Col span={6}>
          <div className="info-last">
            <div className="info-last-title">
              {$i18n.get({
                id: 'aopf.pages.miniapp.version.info.title.Target.App',
                dm: '目标应用程序',
              })}
            </div>
            <Tooltip align="b" v2 trigger={<div className="info-last-text">{channelName}</div>}>
              {channelName}
            </Tooltip>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default AppInfo;
